import * as copy from 'copy-to-clipboard';
import { Form, Formik, FormikErrors, FormikProps } from 'formik';
import * as React from 'react';
import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

import { withDefaultStyles } from '../../../utils/material-ui/hoc';

const validate = async (values): Promise<FormikErrors<any>> => {
    const error: any = {
        mapping: 'failed'
    }
    return error;
}

const template = JSON.stringify([
    {
      "personal": {
        "ssn": "111111111",
        "dob": "10/05/1991",
        "email": "{{ctx.hubspot.crm.email}}",
        "first_name": "John",
        "last_name": "Schuler",
        "phone": "9562528908",
        "years_schooling": "16",
        "dependents": "5,15",
        "marital": {
          "marital_status": 2
        },
        "residence": {
          "mailing_address": {
            "address1": "{{ctx.sdk.geo.address}}",
            "address2": "Apt D",
            "city": "Rebel",
            "state": "CA",
            "zip": "12345"
          },
          "home_address": [
            {
              "address1": "1 Main Street",
              "address2": "Apt D",
              "city": "Rebel",
              "state": "CA",
              "zip": "12345",
              "months": null,
              "own": false,
              "start_date": "11/01/2017"
            },
            {
              "address1": "2 Main Street",
              "address2": "Apt C",
              "city": "Rebel",
              "state": "AL",
              "zip": "54321",
              "months": 6,
              "own": false,
              "start_date": "03/01/2016"
            }
          ]
        }
      },
      "properties": [
        {
          "address1": "{{ctx.plaid.asset.house}}",
          "address2": "",
          "city": "Tatooine",
          "state": "TO",
          "zip": "56262",
          "months": null,
          "own": true,
          "no_of_units": "1",
          "rental_income": "1,234",
          "monthly_hoa": "11",
          "property_type": "2",
          "purchase_price": null,
          "property_use": "2",
          "property_status": "2",
          "title_status": "2",
          "market_value": "300,000",
          "monthly_homeowners_insurance": "100",
          "monthly_mortgage_insurance": "",
          "annual_tax": "1,500",
          "county_fips": "005"
        }
      ],
      "asset_details": {
        "current_ownership": true,
        "assets": [
          {
            "source": "{{ctx.quovo.assets.assetSource1}}",
            "source_type": "{{ctx.quovo.assets.assetType1}}",
            "amount": "{{ctx.quovo.assets.assetAmount1}}"
          }
        ],
        "incomes": [
          {
            "source": "{{ctx.plaid.income.incomeSource1}}",
            "amount": "{{ctx.plaid.income.incomeAmount1}}"
          },
          {
            "source": "{{ctx.plaid.income.incomeSource2}}",
            "amount": "{{ctx.plaid.income.incomeAmount2}}"
          }
        ]
      },
      "declarations": {
        "ongoing_payments": "2"
      },
      "employment_details": {
        "employment": [
          {
            "name": "Rebel Pvt. Ltd",
            "self_employed": "false",
            "independent_contractor": "false",
            "start_date": "11/1/2017",
            "position": "Jedi Master",
            "business_type": "IT Services/Software",
            "years_in_industry": "6",
            "phone": "6282528908",
            "address1": "4 Yavin Prime",
            "city": "Yavin",
            "state": "CA",
            "zip": "45775",
            "annual_salary": "100,000",
            "salary": "8,333.33",
            "payment_type": "salary",
            "annual_bonuses": "23,234",
            "annual_commissions": "4,000"
          },
          {
            "name": "Jedi Council",
            "self_employed": "false",
            "independent_contractor": "",
            "start_date": "2/1/2016",
            "end_date": "11/1/2017",
            "position": "Master",
            "business_type": "IT Services/Software",
            "years_in_industry": "2",
            "phone": "4082168844",
            "address1": "1 Dantooine Pl",
            "city": "Dantooine",
            "state": "CA",
            "zip": "65995",
            "payment_type": "salary"
          }
        ]
      },
      "liability_details": {
        "child_support_amount": "2,000",
        "liabilities": [
          {
            "type": "Z",
            "monthly_amount": 865666,
            "no_of_months_left": 8
          }
        ]
      },
      "credit": {
        "estimated_credit": "excellent"
      },
      "downpayment_additional_source": {
        "note_debt": true
      },
      "hmda": {
        "hmda_male": true,
        "hmda_not_hispanic_or_latino": true,
        "hmda_asian": true
      },
      "primary_borrower": true,
      "econsent": {
        "econsent_status": true,
        "econsented_at": "2018-08-31T15:20:27.841-07:00",
        "reference_id": null
      }
    }
  ], null, 2)

class TemplatesForm extends React.Component<any, any> {

    public render() {
        return (
            <div style={this.props.style}>
                <Formik
                    initialValues={{
                        templates: this.props.config.templates
                    }}
                    onSubmit={this.props.onSubmit}
                    render={this.form}
                    validate={validate}
                    enableReinitialize={true}
                />
            </div>
        );
    }
    private form = (p: FormikProps<any>) => <Form>
        <TextField
            label='Application Info Template'
            name='templates'
            margin="normal"
            variant="outlined"
            placeholder={template}
            multiline={true}
            fullWidth={true}
            rows="4"
            value={p.values.templates}
            onChange={p.handleChange}
            onBlur={p.handleBlur}
        />
        <Button type="submit" color="primary">Save</Button>
        <Button onClick={this.copyTemplate} color="primary">Copy Template to Clipboard</Button>
    </Form>
    private copyTemplate = () => {
        copy(template)
    }
}


const mapStateToProps = (state, ownProps) => {
    return { ...state };
}

export default withDefaultStyles(connect(
    mapStateToProps,
)(TemplatesForm));



// WEBPACK FOOTER //
// ./src/sub-projects/roostify/components/template-form.tsx